import React from 'react';
import {Formik} from "formik";
import Text from "../../Commun/Inputs/Text/Text";

const ForgotPassword = (props) => {
    const {postForgotPassword, loading, onBackToLogin} = props

    const initialValues = {
        email: ''
    }

    return (
        <div className={'p-3 pb-5'}>
            <p className="text-center mb-4" style={{fontSize: '14px'}}>
                Saisissez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </p>
            <Formik initialValues={initialValues} onSubmit={values => postForgotPassword({
                ...values,
                callback_url: `${window.location.origin}/reset-password`
            })}>
                {({handleSubmit, errors, touched, handleChange, handleBlur, values}) => (
                    <form onSubmit={handleSubmit} className={'row'}>
                        <div className='col-8 offset-2 mb-4'>
                            <Text
                                type={'email'}
                                name="email"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                required
                                label='Email'
                                placeholder='Saisissez votre email'
                            />
                        </div>
                        <div className='col-8 offset-2'>
                            <button type="submit" className={`btn btn-block text-center`} style={{minWidth: 200}}>
                                {
                                    loading ?
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                                        : <>Envoyer le lien <span className={'d-inline-block mx-2'}>➜</span></>

                                }
                            </button>
                        </div>
                        <div className='col-12 mt-3 text-center'>
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                onBackToLogin && onBackToLogin();
                            }} style={{fontSize: '14px'}}>
                                Retour à la connexion
                            </a>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default ForgotPassword;
